import { BannerInfo } from '@yourcause/common/banner';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';

@RegisterYCState()
export class BannerState extends BaseYcState {
  readonly banners: BannerInfo[];
  readonly showInactiveNpoBanner: boolean;
}
